import React from 'react'
import { Box, Card, CardBody, Stack, StackDivider } from '@chakra-ui/react'
import ProjectItem from './ProjectItem'

const WorkExperiencProject = ({ project }) => {
    return (
        <>
            <Card>
                <CardBody>
                    <Stack divider={<StackDivider />} spacing='4'>
                        {
                            Object.keys(project).map((item, index) => (
                                <Box key={index}>
                                    {
                                        item === 'ProjectName' && <ProjectItem label="Project Name" value={project['ProjectName']} />
                                    }
                                    {
                                        item === 'TimeLineInProject' && <ProjectItem label="Timeline In Project" value={project['TimeLineInProject']} />
                                    }
                                    {
                                        item === 'Skills' && <ProjectItem label="Skills" value={project['Skills']} />
                                    }
                                </Box>
                            )
                            )
                        }
                    </Stack>
                </CardBody>
            </Card>
            <br />
        </>
    )
}

export default WorkExperiencProject